
/* eslint-disable vue/no-mutating-props */
// `target` is an orchestrator-owned person (logic.js newPerson()) — the same
// component serves the primary client (§2) and, via props, new-guidance
// attendees inside AttendeeCard.
import { mapGetters } from 'vuex'
import { COPY, MEDICARE_PARTS_OPTIONS } from './copy'
import SpecialCircumstances from './SpecialCircumstances.vue'
import zipCounty from './zip-county'
import AddressSearch from '~/components/AddressSearch.vue'

export default {
    components: { SpecialCircumstances, AddressSearch },
    mixins: [zipCounty],
    props: {
        target: { type: Object, required: true },
        showHeader: { type: Boolean, default: true },
        stepNumber: { type: [String, Number], default: 2 },
        consentLabel: { type: String, default: COPY.s2.consentClient },
        // #727: the state was chosen in step 1 (Other source, open state) and
        // decided eligibility, so nothing here may change it.
        lockState: { type: Boolean, default: false },
    },
    data () {
        return { COPY, partsOptions: MEDICARE_PARTS_OPTIONS }
    },
    computed: {
        ...mapGetters(['genders']),
        // Defensive (not mapGetters): ReturningClientFields shares this same
        // pattern but has no other $store dependency, so both stay guarded
        // rather than assuming $store is present.
        usStates () {
            return (this.$store && this.$store.getters.usStates) || []
        },
    },
    methods: {
        // #727: overrides the zip-county mixin's set(). A locked state ignores
        // every writer in this card -- the address pick, a ZIP change (the
        // mixin's onZip nulls state) and the county backfill -- not just one.
        set (key, val) {
            if (key === 'state' && this.lockState) return
            this.$set(this.target, key, val)
        },
        // #689: ZIP first. onZip nulls state synchronously and the county
        // lookup only backfills state while it is still empty, so setting the
        // picked state right after means it wins over the county-derived one.
        onAddressPick (a) {
            this.onZip(a.zip_code || '')
            this.set('street_1', a.street_1 || '')
            this.set('street_2', a.street_2 || '')
            this.set('city', a.city || '')
            this.set('state', a.state || null)
        },
        // #680 Phase 2a: overrides zip-county.js's applyCounty (mixed in
        // below) now that an explicit state <select> sits beside ZIP. The
        // mixin's version backfills state unconditionally from the resolved
        // county; here an admin's own pick — made in the window between a
        // ZIP lookup and confirming a multi-county match — must not be
        // silently clobbered. Retyping the ZIP itself still resets state via
        // onZip (untouched, shared mixin), same as it resets fips/county —
        // a changed ZIP legitimately invalidates the old location.
        applyCounty (c) {
            this.set('fips', c.fips)
            this.set('county', `${c.county || c.name}, ${c.state}`)
            if (!this.target.state) this.set('state', c.state || null)
        },
    },
}
